import { Box, Button, constants, RulerIcon } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { messages } from './messages';

export interface SizeGuideButtonProps {
  productTypeId: string;
  workId: number;
  onClick?: () => void;
}

const SizeGuideModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "SizeGuideModal" */
      './SizeGuideModal'
    ).then(({ SizeGuideModal: Component }) => Component),
  { ssr: false, loading: () => null }
);

export const SizeGuideButton: React.FC<SizeGuideButtonProps> = ({
  productTypeId,
  workId,
  onClick,
}) => {
  const intl = useIntl();

  const [open, setOpen] = useState(false);

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }

    setOpen(true);
  };

  const onClosedRequested = () => setOpen(false);

  return (
    <>
      <Box>
        <Button
          onClick={handleOnClick}
          intent={constants.PRIMARY}
          size={constants.SMALL}
          iconBefore={<RulerIcon />}
        >
          {intl.formatMessage(messages.openButtonText)}
        </Button>
      </Box>
      <SizeGuideModal
        open={open}
        onClosedRequested={onClosedRequested}
        productTypeId={productTypeId}
        workId={workId}
      />
    </>
  );
};
